// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__3kGgS"};